import { Component, input } from '@angular/core';
import { CurrencyFormatPipe } from '@webapp/core/pipes/currencyFormat';
import { ICoverageItem } from '@webapp/payments';

@Component({
	selector: 'app-coverage-item',
	imports: [CurrencyFormatPipe],
	templateUrl: './coverage-item.component.html',
	styleUrl: './coverage-item.component.scss',
})
export class CoverageItemComponent {
	item = input<ICoverageItem>();
}
